import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import EventyService from "../EventyService";
import {TopAlertInformacja, TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import {Link} from "react-router-dom";

export default class EventyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            setLoader: false,
            modalError: false,
            listaZapisanych: [],
            currentEvent:null

        };

        this.renderButtony = this.renderButtony.bind(this)
    }

    componentDidMount() {
    }

    onClickPokazUczesnikow(obj) {
        this.setState({
            showModal: true,
            setLoader: true,
            modalError: false,
            listaZapisanych: [],
            currentEvent:obj
        })

        EventyService.pobierzListeZapisanychDoEventu(obj.id).then(function (response) {
            if (response.status < 300) {
                this.setState({
                    showModal: true,
                    setLoader: false,
                    modalError: false,
                    listaZapisanych: Array.from(response.data,item=>{
                        return{
                            imieNazwisko:item.imie+' '+item.nazwisko,
                            ...item
                        }
                    }),
                })
            } else {
                this.setState({
                    showModal: true,
                    setLoader: false,
                    modalError: true,
                    listaZapisanych: [],
                })
            }
        }.bind(this)).catch(function (err) {
            this.setState({
                showModal: true,
                setLoader: false,
                modalError: true,
                listaZapisanych: [],
            })
        }.bind(this))
    }

    renderButtony(cell, row) {
        return (<TopButtonAction iconType={'fa fa-group'} text={'Pokaż uczestników'} btnColor={'default'} onClick={() => {
            this.onClickPokazUczesnikow(row)
        }}/>)
    }

    renderAktywny(cell, row) {
        if (Boolean(cell)) {
            return (<div><i className={'fa fa-check'} style={{color: 'forestgreen'}}></i> aktywny</div>)
        }
        else {
            return (<div><i className={'fa fa-times'} style={{color: 'firebirck'}}></i> nieaktywny</div>)
        }
    }

    renderCurrentEvent(){
        if(Boolean(this.state.currentEvent)){
            return(<div style={{marginBottom:'15px'}}>
                <h4>
                    <span>
                    <span className={'label label-ebus-default'} style={{fontSize:'16px', marginRight:'5px'}}>{this.state.currentEvent.id}</span> {this.state.currentEvent.tytul}
                    </span>
                    <span style={{margin:'0 15px', color:'#ccc',fontWeight:'normal'}}>|</span>
                    <span style={{fontSize:'12px', color:'grey', fontStyle:'italic',fontWeight:'normal'}}>
                        <span>Dodano {this.state.currentEvent.dataWpisu},</span>
                        <span style={{marginLeft:'10px'}}>Ilość zapisanych osób: {this.state.listaZapisanych.length}</span>
                    </span>
                </h4>
            </div>)
        }
    }

    formatZobaczKlienta(id){
        if(id===1){
            return ''
        }else
        return <Link to={'/zarzadzanie-klientami/klient/'+id} target={'_blank'}><i className={'fa fa-external-link'}></i> Zobacz stronę klienta</Link>
    }

    render() {

        const options = {
            defaultSortName: 'dataWpisu',
            sortOrder: 'desc',
        }

        return (
            <div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    hover
                    >
                        <TableHeaderColumn dataField='id' isKey dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => (<span className={'label label-ebus-default'}>{cell}</span>)}
                        >ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='dataWpisu' dataSort
                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Data wpisu</TableHeaderColumn>
                        <TableHeaderColumn dataField='tytul' dataSort
                                           thStyle={tabgrid.tg12} tdStyle={tabgrid.tg12}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Tytuł</TableHeaderColumn>
                        <TableHeaderColumn dataField='aktywny' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.renderAktywny}
                        >Czy aktywny?</TableHeaderColumn>
                        <TableHeaderColumn dataField='id'
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                           dataFormat={this.renderButtony}
                        >Pokaż uczestników</TableHeaderColumn>
                    </BootstrapTable>
                </div>
                {
                    this.state.showModal ?
                        <div id={'EBUSModalContainerBG'}>
                            <div id={'modalContainer'}>
                                <div id={'modalTextContent'} style={{width: '1000px', maxHeight: '70vh', overflowY: 'auto'}}>
                                    <div>
                                        <div className={'pull-right'}>
                                            <TopButtonAction onClick={() => {
                                                this.setState({
                                                    showModal: false,
                                                    setLoader: false,
                                                    modalError: false,
                                                    listaZapisanych: [],
                                                    currentEvent:null
                                                })
                                            }}
                                                             elementStyle={{color: 'firebrick'}}
                                                             btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                                            />
                                        </div>
                                        <div style={{clear: 'both', height: '5px'}}></div>
                                        <div>
                                            {
                                                this.state.setLoader ?
                                                    <div id={'simple-small-loader'}>
                                                        <i className={'fa fa-spinner fa-spin'}></i>
                                                    </div>
                                                    :
                                                    this.state.modalError ?
                                                        <TopAlertUwaga text={'Wystąpił błąd!'}/>
                                                        :
                                                        this.state.listaZapisanych.length === 0 ?
                                                            <div>
                                                                <div>
                                                                    {this.renderCurrentEvent()}
                                                                </div>
                                                                <TopAlertInformacja text={'Jeszcze nikt nie zapisał się do tego eventu'}/>
                                                            </div>
                                                            :
                                                            <div>
                                                                <div>
                                                                    {this.renderCurrentEvent()}
                                                                </div>
                                                                <div>
                                                                    <BootstrapTable data={this.state.listaZapisanych}
                                                                                    hover
                                                                    >

                                                                        <TableHeaderColumn dataField='id_event_wpis' isKey
                                                                                           hidden={true}
                                                                        >ID</TableHeaderColumn>
                                                                        <TableHeaderColumn dataField='imieNazwisko' dataSort
                                                                                           thStyle={tabgrid.tg8} tdStyle={tabgrid.tg8}
                                                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                                        >Klient</TableHeaderColumn>
                                                                        <TableHeaderColumn dataField='e_mail' dataSort
                                                                                           thStyle={tabgrid.tg7} tdStyle={tabgrid.tg7}
                                                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                                        >Email</TableHeaderColumn>
                                                                        <TableHeaderColumn dataField='nr_tel' dataSort
                                                                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                                                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                                        >Telefon</TableHeaderColumn>
                                                                        <TableHeaderColumn dataField='id_kl'
                                                                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                                                                           dataFormat={(cell,row)=>this.formatZobaczKlienta(cell)}
                                                                        >Zobacz klienta</TableHeaderColumn>
                                                                    </BootstrapTable>
                                                                </div>
                                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div style={{clear: 'both'}}></div>
                            </div>
                        </div>
                        :
                        ''
                }

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/eventy/components/EventyTable.js